module.exports = __webpack_public_path__ + "img/c34.de48f93f.png";